var ExpertiseListingWithCallout = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

ExpertiseListingWithCallout.prototype.init = function () {

};

export default ExpertiseListingWithCallout;
